/**
 * テスト・検証時にURLクエリパラメータを毎回付け直す手間を省くため、
 * 一度有効化するとセッション中はページ遷移後も設定が維持される。
 */
const QUERY_KEY_USE_NEW_IMPORT = "isNewVideoPlayerImport";

const parseFlagValue = (value: string): boolean => {
  return value === "1" || value.toLowerCase() === "true";
};

const readFlagFromQuery = (
  searchParams: URLSearchParams
): boolean | undefined => {
  if (!searchParams.has(QUERY_KEY_USE_NEW_IMPORT)) {
    return undefined;
  }

  const queryValue = searchParams.get(QUERY_KEY_USE_NEW_IMPORT);

  if (queryValue === null || queryValue === "") {
    return true;
  }

  return parseFlagValue(queryValue);
};

const writeFlagToSessionStorage = (enabled: boolean): void => {
  try {
    window.sessionStorage.setItem(
      QUERY_KEY_USE_NEW_IMPORT,
      enabled ? "1" : "0"
    );
  } catch {
    // sessionStorageが利用できない環境では保存せずにフォールバックする
  }
};

const readFlagFromSessionStorage = (): boolean => {
  try {
    return window.sessionStorage.getItem(QUERY_KEY_USE_NEW_IMPORT) === "1";
  } catch {
    // sessionStorageが利用できない環境では無効扱いにフォールバックする
    return false;
  }
};

export const syncNewVideoPlayerImportFlagFromQuery = (): void => {
  if (typeof window === "undefined") return;

  const searchParams = new URLSearchParams(window.location.search);
  const enabled = readFlagFromQuery(searchParams);

  if (enabled !== undefined) {
    writeFlagToSessionStorage(enabled);
  }
};

export const isNewVideoPlayerImportEnabled = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const enabledFromQuery = readFlagFromQuery(searchParams);

  if (enabledFromQuery !== undefined) {
    writeFlagToSessionStorage(enabledFromQuery);
    return enabledFromQuery;
  }

  return readFlagFromSessionStorage();
};
